module.exports = __webpack_public_path__ + "img/tairitsu.00d8ec71.png";